export default __webpack_public_path__ + "static/media/safari_setting_partial_1.b1e8b483.png";